__turbopack_context__.v({
  "root": "b_WIqa_root",
  "rootInline": "b_WIqa_rootInline",
});
